<template>
  <div class="settlement_container">
    <!-- 搜索区域 -->
    <global-tag>
      <span slot="title">结算管理</span>
      <div class="search" slot="search">
        <el-form label-width="100px">
          <el-row>
            <el-col :span="5">
              <el-form-item label="建设单位：">
                <el-input
                  v-model="username"
                  placeholder="请输入建设单位名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="5">
              <el-form-item label="状态：">
                <el-select v-model="status" placeholder="请选择状态">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="审核未通过" value="1"></el-option>
                  <el-option label="审核通过" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="3" :offset="7">
              <el-button type="primary" class="searchBtns" @click="search"
                >搜索</el-button
              >
            </el-col>
             <el-col :span="4">
              <el-button type="info" class="resetReach" @click="reset"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
    </global-tag>
    <div class="screen_container" style="margin-top: 24px;text-align: right;">
      <el-button-group>
        <el-button type="primary" icon="el-icon-refresh" class="dropRests" @click="Reset1"></el-button>
        <!-- <el-button type="primary" style="padding: 10px 20px"> -->
          <el-dropdown
                    class="dropdown1 dropRests"
                    trigger="click"
                    
                    :hide-on-click="false"
                >
            <span class="el-dropdown-link">
              <i class="el-icon-s-grid el-icon--right" style="color: #fff"></i>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="table_checkbox">
              <el-dropdown-item>
                <el-checkbox-group
                  v-model="tableChekbox"
                  @change="tableChekboxChange"
                >
                  <el-checkbox label="序号"></el-checkbox><br/>
                  <el-checkbox label="建设单位"></el-checkbox><br/>
                  <el-checkbox label="负责人"></el-checkbox><br/>
                  <el-checkbox label="费用"></el-checkbox><br/>
                  <el-checkbox label="审核状态"></el-checkbox><br/>
                  <el-checkbox label="提交时间"></el-checkbox><br/>
                  <el-checkbox label="操作"></el-checkbox>
                </el-checkbox-group>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        <!-- </el-button> -->
      </el-button-group>
    </div>
    <!-- 页面表格 -->
    <div class="table_container">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="550px"
        :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
        border
      >
        <el-table-column
          width="80"
          align="center"
          type="index"
          label="序号"
          v-if="this.tempTableChekbox.findIndex((item) => item == '序号') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="建设单位"
          prop="constructUnit"
          v-if="this.tempTableChekbox.findIndex((item) => item == '建设单位') != -1"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          align="center"
          label="负责人"
          prop="leader"
          v-if="this.tempTableChekbox.findIndex((item) => item == '负责人') != -1"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          align="center"
          label="费用"
          prop="totalPrice"
          v-if="this.tempTableChekbox.findIndex((item) => item == '费用') != -1"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          align="center"
          label="提交时间"
          prop="createDate"
          v-if="this.tempTableChekbox.findIndex((item) => item == '提交时间') != -1"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column width="120" align="center" label="操作" v-if="this.tempTableChekbox.findIndex((item) => item == '操作') != -1">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="查看"
              placement="top-start"
            >
              <img
                src="../assets/img/detail.png"
                style="cursor: pointer"
                @click="handleTableForm('详情', scope.row)"
              />
            </el-tooltip>
           
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_container">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="pageNo"
        @size-change="handletableSize"
        @current-change="handleTableChange"
      ></el-pagination>
    </div>
    <!-- 表格表单弹窗 -->
    <el-dialog
      :title="dialogVisibleTitle"
      :visible.sync="dialogVisible"
      width="50%"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="dialog_content">
        <el-form
          label-position="left"
          label-width="100px"
          :model="formData"
          :disabled="dialogVisibleTitle == '详情'"
        >
          <el-form-item label="建设单位：">
            <el-input
              v-model="formData.constructUnit"
              placeholder="请输入建设单位"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人：">
            <el-input
              v-model="formData.leader"
              placeholder="请输入负责人"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="申请时间：">
            <el-input
              v-model="formData.createDate"
              placeholder="请输入申请时间"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="费用详情：">
            <el-table
              :data="formData.elderlyInformationList"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
              border
            >
              <el-table-column
                type="index"
                width="70"
                label="序号"
                align="center"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="name"
                label="姓名"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="price"
                label="费用"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="acceptanceApprovalStatus"
                label="状态"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.acceptanceApprovalStatus == 0"
                    >待验收</span
                  >
                  <span v-if="scope.row.acceptanceApprovalStatus == 1"
                    >已验收</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="改造清单"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="查看"
                    placement="top-start"
                  >
                    <img
                      src="../assets/img/detail.png"
                      style="cursor: pointer"
                      @click="handleDetaiClick(scope.row)"
                    />
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <div class="total_wrapper" v-if="this.formData.elderlyInformationList&&this.formData.elderlyInformationList.length != 0">
              <span class="total_title">费用（合计）</span>
              <span class="total_count">{{ detailTatol }}</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="dialogVisibleTitle != '详情'"
      >
        <el-button type="primary" @click="save">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 清单列表弹窗 -->
    <el-dialog
      title="清单列表"
      :visible.sync="detailListDialogVisible"
      width="50%"
      class="dialog_container"
      @close="detailListDialogVisibleClose"
    >
      <div class="dialog_content">
        <el-table
          :data="detailListtableData"
          tooltip-effect="dark"
          style="width: 100%"
          height="190px"
          :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
          border
          :span-method="arraySpanMethod"
        >
          <el-table-column
            prop="productName"
            label="产品名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="openPrice"
            label="单价"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="number"
            label="数量"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="price"
            label="费用"
            align="center"
          ></el-table-column>
        </el-table>
        <div class="total_wrapper" v-if="detailListtableData.length != 0">
          <span class="total_title">费用（合计）</span>
          <span class="total_count">{{ detailListtableTatol }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request.js";
import globalTag from "../components/globalTag";
export default {
  name: "standard",
  data() {
    return {
      username: "", //姓名
      status: "", //状态
      tableData: [],
      formData: { //table表单
        unit: "", //单位
        leader: "", //负责人
        createDate: "", //费用
        approvalStatus: '0', //审核状态
        approvalOpinion: '', //原因
        elderlyInformationList: [], //费用详情
      },
      dialogVisible: false, //table表单弹窗
      dialogVisibleTitle: "", //table表单弹窗title
      detailListDialogVisible: false, //清单列表弹窗
      detailListtableData: [//清单列表table
        
      ],
      detailListtableTatol: 0,
      pageSize: 10,
      pageNo: 1,
      total: 0,
      tempTableChekbox: [
        "序号",
        "建设单位",
        "负责人",
        "费用",
        "提交时间",
        '操作'
      ],
      tableChekbox: [
        "序号",
        "建设单位",
        "负责人",
        "费用",
        "提交时间",
        '操作'
      ],
    };
  },
  components: {
    globalTag,
  },
  computed: {
    detailTatol () {
      let tatol = 0
      this.formData.elderlyInformationList.forEach(item => {
        if(!!item && !!item.price) {
          tatol += Number(item.price)
        }
      })
      return tatol
    }
  },
  inject: ["reload"], //注入
  methods: {
    // 页面刷新
    Reset() {
      this.reload();
    },
      // 保留条件刷新
        Reset1(){
            this.showList();
            this.tableChekbox =  [
              "序号",
              "建设单位",
              "负责人",
              "费用",
              "费用详情",
              "提交时间",
              "审核状态",
              '操作'
            ]
        },
    //table列checkbox发生变化
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item);
    },
    //处理table表格表单
    handleTableForm(title, date) {
      this.dialogVisibleTitle = title;
      this.dialogVisible = true;
      switch (title) {
        case "详情":
          this.look(date);
        case "审核":
          this.look(date);
          break;
      }
    },
    //table表格表单弹窗关闭时事件
    dialogVisibleClone() {
      // this.dialogVisible = false;
      console.log('123456')
    },
    //清单列表弹窗关闭回调
    detailListDialogVisibleClose() {
      // this.dialogVisible = false;
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
    },
    //审核表单表格详情
    handleDetaiClick(date) {
      this.detailListDialogVisible = true;
      let params = {
        id: date.id,
      };
      params = Object.assign({}, params);
      request({
         url: "/jjyl/admin/settlementManage/info/geteElderlySubProManage",
        method: "POST",
        data: params,
      }).then((res) => {
        if(res.code == 200) {
          this.detailListtableTatol = 0
          this.detailListtableData = res.content;
          if(this.detailListtableData == null || this.detailListtableData == 'null') {
            this.detailListtableData = []
          }
          let total = 0
          this.detailListtableData.forEach(item => {
            total += Number(item.price)
          })
          this.detailListtableTatol = total
        }
      });
    },
    //删除当前单元格
    deleteId(date) {
      let params = {
        id: date.id,
      };
      params = Object.assign({}, params);
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
           url: "/jjyl/admin/settlementManage/info/deleteById",
          method: "POST",
          data: params,
        }).then((res) => {
          if (res.code = 200) {
            this.$message.success('删除成功')
            this.showList();
          }else {
            this.$message.success('删除失败')
          }
        });
      });
    },
    //pagesize发生改变
    handletableSize(val) {
      this.pageSize = val
      this.showList()
    },
    //页码发生改变
    handleTableChange(val) {
      this.pageNo = val
      this.showList()
    },
    //获取表格数据
    async showList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
		qujiId:JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
		shengjiId:JSON.parse(localStorage.getItem('czUserInfo')).shengjiId,
		shijiId:JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
		stationId:JSON.parse(localStorage.getItem('czUserInfo')).stationId,
		shequjiId:JSON.parse(localStorage.getItem('czUserInfo')).shequjiId,
      };
      params = Object.assign({}, params);
      await request({
         url: "/jjyl/admin/settlementManage/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if(res.code == 200) {
          this.tableData = res.content.list;
          this.total = res.content.count;
          if(res.content == null || res.content == 'null') {
            this.tableData = []
            this.total = 0
          }
          this.tableData.forEach(item => {
            !item.approvalStatus && (item.approvalStatus = '')
          })
        }
      });
    },
    //搜索
    async search() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
		qujiId:JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
		shengjiId:JSON.parse(localStorage.getItem('czUserInfo')).shengjiId,
		shijiId:JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
		stationId:JSON.parse(localStorage.getItem('czUserInfo')).stationId,
		shequjiId:JSON.parse(localStorage.getItem('czUserInfo')).shequjiId,
      };
      if(this.username !='') {
        params.constructUnit = this.username
      }
      if(this.status !='') {
        params.approvalStatus = this.status
      }
      params = Object.assign({}, params);
      await request({
         url: "/jjyl/admin/settlementManage/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.content != null) {
          this.tableData = res.content.list;
          this.total = res.content.count;
        } else {
          this.tableData = [];
          this.total = 0;
        }
      });
    },
    //表格审核
    async save() {
      let self = this
      if(this.formData.approvalStatus === '' || this.formData.approvalStatus === null || this.formData.approvalStatus === undefined) {
        self.$message.error('审核状态不能为空')
        return
      }
      
      if(this.formData.approvalStatus == 1) {
        if(this.formData.approvalOpinion === null || this.formData. approvalOpinion === undefined || this.formData.approvalOpinion.replace(/\s*/g, "")=== '') {
          self.$message.error('审核未通过,请填写原因')
          return
        }
      }
      let params = {
        ...this.formData,
      };
      params = Object.assign({}, params);
      await request({
         url: "/jjyl/admin/settlementManage/info/update",
        method: "POST",
        data: params,
      }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.dialogVisible = false;
          this.showList();
        }
      });
    },
    //获取当前表格单远行数据
    async look(date) {
      let params = {
        id: date.id,
      };
      params = Object.assign({}, params);
      await request({
         url: "/jjyl/admin/settlementManage/info/getById",
        method: "POST",
        data: params,
      }).then((res) => {
        if(res.content.approvalStatus == null) {
          this.$set(res.content,'approvalStatus', '')
        }
        let temp = Object.assign({},res.content)
        this.$set(this,'formData',temp)
        
        if (!this.formData.elderlyInformationList){
          this.formData.elderlyInformationList = []
        };
        // if(this.formData.elderlyInformationList.length == 0 || this.formData.elderlyInformationList[0] == null) {
        //   this.formData.elderlyInformationList = []
        //   return
        // }
      });
    },
    reset() {
      this.pageSize = 10
      this.pageNo = 1
      this.username = "";
      this.status = "";
      this.showList();
      
    },
  },
  created() {
    this.showList();
  },
};
</script>

<style lang="less" scoped>
.total_wrapper {
  display: flex;
  border: 1px solid #EBEEF5;
  border-top: none;
  span {
    color: #606266;
    line-height: 50px;
  }
  .total_title {
    width: 25%;
    text-align: center;
    border-right: 1px solid #EBEEF5;
  }
  .total_count {
    flex: 1;
    text-align: center;
  }
}
.settlement_container {
  .table_container {
    width: 100%;
  }
}
</style>